import {
  CREATE_SHARE_DOMAIN,
  SAVE_SHARE_DOMAIN,
  RESET_SHARES_ACTION,
  RESET_SHARES,
  GET_FORCE_SSL,
  SAVE_FORCE_SSL
} from '../actions/share'
import { secureShareLink, parseText } from '@/helper/helper'
import { shareLink } from '@/utils/ReactNative'
import { settingsDB } from '@/firestoreDB'
import {RegisterEvent} from '@/analytics'

const getDefaultState = () => ({
  shareLinkData: {},
  isForceSSL: true
})

const state = getDefaultState()

const getters = {
  getShareData: state => state.shareLinkData,
  getForceSSL: state => state.isForceSSL
}

const actions = {
  [GET_FORCE_SSL]: ({commit, getters}) => {
    getters.isAuthenticated() && settingsDB.doc('share')
      .get()
      .then(doc => {
        if (doc.exists) {
          commit('SAVE_FORCE_SSL', doc.data().force_ssl)
        }
      })
  },
  [CREATE_SHARE_DOMAIN]: ({ commit, getters }, doc) => {
    const { post, share } = doc
    let link = ''
    settingsDB
      .doc('share')
      .get()
      .then(doc => {
        if (doc.exists) {
          const shareDomain = doc.data().share_domain
          link =
            shareDomain !== ''
              ? secureShareLink(
                shareDomain,
                post.created_at,
                post.key,
                getters.firebaseUUID()
              )
              : share.default_url
        } else link = share.default_url
        RegisterEvent('chi_post_share_click', {
          target_id: link,
          target_type: 'link'
        })
        let shareData = {
          url: link,
          title: share.author,
          message: parseText(share.content),
          subject: 'Compartir link'
        }
        shareLink(shareData)
        commit(SAVE_SHARE_DOMAIN, shareData)
      })
  },
  [RESET_SHARES_ACTION]: ({commit}) => {
    commit(RESET_SHARES)
  }
}

const mutations = {
  [SAVE_SHARE_DOMAIN]: (state, shareData) => {
    state.shareLinkData = { ...shareData }
  },
  [RESET_SHARES]: (state) => {
    Object.assign(state, getDefaultState())
  },
  [SAVE_FORCE_SSL]: (state, forceSSL) => {
    state.isForceSSL = forceSSL
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/shareConnection.js